import React from 'react';
import { A } from '@xingternal/rebranding-adapter';
import { Text } from '@xingternal/winery-ui/lib/Text';
import { Flex } from '@xingternal/winery-ui/lib/UI';
import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';
import QuestionMarkIcon from './assets/QuestionMark.svg';

type HowToHintProps = {
  mainText: string;
  urlText: string;
  url: string;
};

const ItemWidth = '634px';

const Item = styled(Flex)`
  margin: auto;
  max-width: ${ItemWidth};
  margin-bottom: ${themeGet('space.5')};
  align-items: center;
`;

const ItemText = styled(Text)`
  font-size: ${themeGet('fontSizes.2')};
  line-height: ${themeGet('lineHeights.2')};
  margin-top: ${themeGet('space.1')};
  text-align: left;
`;

const StyledLink = styled(A)`
  cursor: pointer;
`;

const Icon = styled.img`
  width: ${themeGet('space.8')};
  height: ${themeGet('space.8')};
  margin-right: ${themeGet('space.5')};
`;

const HowToHint = ({ mainText, urlText, url }: HowToHintProps) => (
  <Item>
    <Icon src={QuestionMarkIcon} data-testid="question-mark-icon" />
    <ItemText>
      {mainText}&nbsp;
      <StyledLink href={url} target="_blank" rel="noopener">
        {urlText}
      </StyledLink>
    </ItemText>
  </Item>
);

export { HowToHint };
